// Klaviyo Popup Triggers
// This script handles all Klaviyo popup triggers across the theme

document.addEventListener('DOMContentLoaded', function() {
  // Function to initialize Klaviyo triggers
  function initKlaviyoTriggers() {
    const klaviyoButtons = document.querySelectorAll('.klaviyo_form_trigger');
    
    klaviyoButtons.forEach(function(button) {
      // Remove any existing event listeners to prevent duplicates
      button.removeEventListener('click', handleKlaviyoClick);
      // Add the event listener
      button.addEventListener('click', handleKlaviyoClick);
    });
  }
  
  // Klaviyo click handler function
  function handleKlaviyoClick(event) {
    event.preventDefault();
    
    // Check if Klaviyo is loaded and form ID is available
    if (typeof window._klOnsite !== 'undefined' || typeof window.klaviyo !== 'undefined') {
      window._klOnsite = window._klOnsite || [];
      
      // Get the form ID from theme settings
      const formId = document.body.getAttribute('data-klaviyo-form-id') || 
                     document.documentElement.getAttribute('data-klaviyo-form-id') ||
                     document.querySelector('meta[name="klaviyo-form-id"]')?.content;
      
      if (formId) {
        window._klOnsite.push(['openForm', formId]);
      } else {
        console.warn('Klaviyo form ID not found. Please check your theme settings.');
      }
    } else {
      console.warn('Klaviyo is not loaded. Please check your Klaviyo integration.');
    }
  }
  
  // Initialize triggers on page load
  initKlaviyoTriggers();
  
  // Re-initialize when new content is loaded (for AJAX/dynamic content)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('klaviyo_form_trigger') ||
                  node.querySelector && node.querySelector('.klaviyo_form_trigger')) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      
      if (shouldReinit) {
        initKlaviyoTriggers();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}); 